<template>
  <div class="setup-widget text-dark" :class="[{setupWidgetOpen: showModal}, {animateSlide: animateSlide}]">
    <div class="setup-widget__button" @click="setShowModal">
      <div class="setup-widget__button__text">{{ $t('vue2.setupWidget.get_going_easy') }}</div>
      <div class="pointer setup-widget__button__close">
        <span v-if="showModal" class="icon-cross2"></span>
        <span v-else class="icon-arrow-up4"></span>
      </div>
    </div>
    <arrow :setupWidget="true"
           v-if="showModal && activeOnboardingStep === 0 && showLocalOnboardingArrow"
           :style="{'top': onboardArrowTopPx +'px'}"></arrow>
    <div class="setup-widget__header">
      <div class="onboarding_section">
        <div class="setup-widget__header pad-20 pad-0-top">
          <h1 class="center text-white">{{ $t('vue2.setupWidget.get_going_easy') }}</h1>
          <doughnut :animate="true" :steps="stepsLength" :stepNum="howManyDone"></doughnut>
        </div>
      </div>
      <ul class="setup-widget__steps">
        <li v-for="(step, index) in stepNumbers"
            class="setup-widget__steps__step js-onboard-item-click js-setupWidgetEvent"
            @click="stepFnc(step.stepNum, step.title)"
            :class="{'isDone': step.done}">
          <template v-if="step.guide.length > 1">
            <div @click="openYouTube(step.videoid)" class="youtube-popup js-setupWidgetEvent step__button__video-guide">
              <!-- <a :href="step.guide" data-lity class="youtube-popup js-setupWidgetEvent step__button__video-guide"> -->
              <span class="step__number js-setupWidgetEvent" :class="{stepNumberDone: step.done}">
                <span v-if="step.done"
                      class="icon-checkmark4 js-setupWidgetEvent">
                </span>
                <span v-else class="step__number__play icon-play4 js-setupWidgetEvent"></span>
              </span>
              <span class="step-text js-setupWidgetEvent"> {{ step.title }}</span>
              <!-- </a> -->
            </div>
          </template>
          <template v-else>
            <div class="js-setupWidgetEvent step__button__video-guide">
              <span class="step__number js-setupWidgetEvent" :class="{stepNumberDone: step.done}">
                <span v-if="step.done"
                      class="icon-checkmark4 js-setupWidgetEvent">
                </span>
                <span v-else class="js-setupWidgetEvent">{{ index + 1 }}</span>
              </span>
              <span class="step-text js-setupWidgetEvent"> {{ step.title }}</span>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div class="support-section">
      <div class="support-section__list">
        <a @click.prevent="showIntercom" href=""><span class="icon-bubbles4"></span>
          {{ $t('vue2.setupWidget.write_us') }}</a>
        <template v-if="country === 'dk'">
          <a href="http://support.docendo.dk/"><span class="icon-question3"></span>
            {{ $t('vue2.setupWidget.support_forum') }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import doughnut from '../AppGraphs/StepDoughnut'
import eventbus from '../../eventbus'
import arrow from '../onboarding/OnboardArrow'
import doYouTube from '../YouTube/DoYouTube'

export default {
  components: {doughnut, arrow, doYouTube},
  computed: {
    showModal () {
      return eventbus.showSetupWidget
    },
    user () {
      return this.$store.state.user
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    activeOnboardingStep () {
      return this.$store.state.onboardingStep
    },
    showOnboardingArrow () {
      return eventbus.showOnboardingArrow
    },
    klassCals () {
      return this.$store.getters.allKlassCalendarsInHash
    },
    stepNumbers () {
      if (this.country === 'dk') {
        return this.stepsDK
      } else if (this.country === 'no') {
        return this.stepsNO
      } else {
        return this.stepsEN
      }
    },
    stepsLength () {
      return this.stepNumbers.length
    },
    howManyDone () {
      let doneSteps = this.stepNumbers.filter(obj => {
        return obj.done === true
      })
      return doneSteps.length
    }
  },
  watch: {
    userSettings (val, oldVal) {
      const obj = this.userSettings
      this.progressed = Object.keys(obj).filter(key => {
        return key.startsWith('setup_widget_progress')
      })
      this.checkProgress()
    },
    showModal (val, oldVal) {
      console.log('showModal', val)
    }
  },
  data () {
    return {
      animateSlide: false,
      onboardArrowTopPx: 0,
      showLocalOnboardingArrow: false,
      progressed: [],
      country: window.SCHOOL.country.toLowerCase(),
      stepsNO: [
        {
          title: 'Opprett klasser - (0:36)',
          videoid: 'P9lc_0-64kc',
          guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
          dbName: 'setup_widget_progress_klass',
          done: false,
          stepNum: 1
        },
        {
          title: 'Opprett lærere/brukere - (0:44)',
          videoid: 'X-w0i3MFeL4',
          guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
          dbName: 'setup_widget_progress_users',
          done: false,
          stepNum: 2
        },
        {
          title: 'Opprett lokaler - (0:37)',
          videoid: '8FoyUOiwdPk',
          guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
          dbName: 'setup_widget_progress_rooms',
          done: false,
          stepNum: 3
        },
        {
          title: 'Opprett fellestimeplaner - (2:09)',
          videoid: '39daX1u0238',
          guide: 'https://www.youtube.com/watch?v=DI4d0auYfg4&feature=youtu.be',
          dbName: 'setup_widget_progress_merge',
          done: false,
          stepNum: 4
        },
        {
          title: 'Legg inn ferier og helligdager - (0:39)',
          videoid: 'KmLDUVlzhXA',
          guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
          dbName: 'setup_widget_progress_vacation',
          done: false,
          stepNum: 5
        },
        {
          title: 'Timeplanlegging i klasser - (2:55)',
          videoid: 's6b7b07ZHl0',
          guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
          dbName: 'setup_widget_progress_scheduling',
          done: false,
          stepNum: 6
        }
      ],
      stepsDK: [
        {
          title: 'Opret klasser - (1:01)',
          videoid: '5gjODdkqRDI',
          guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
          dbName: 'setup_widget_progress_klass',
          done: false,
          stepNum: 1
        },
        {
          title: 'Opret lærere/brugere - (0:41)',
          videoid: 'YtujiFzH50A',
          guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
          dbName: 'setup_widget_progress_users',
          done: false,
          stepNum: 2
        },
        {
          title: 'Opret lokaler - (0:39)',
          videoid: '2XQjHWLvyrM',
          guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
          dbName: 'setup_widget_progress_rooms',
          done: false,
          stepNum: 3
        },
        {
          title: 'Opret fletteskemaer - (02:41)',
          videoid: 'VNt1m80YEsI',
          guide: 'https://www.youtube.com/watch?v=VNt1m80YEsI&feature=youtu.be',
          dbName: 'setup_widget_progress_merge',
          done: false,
          stepNum: 4
        },
        {
          title: 'Indtast feriedage - (0:39)',
          videoid: '0XB5A0xr-N0',
          guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
          dbName: 'setup_widget_progress_vacation',
          done: false,
          stepNum: 5
        },
        {
          title: 'Skemalægning i klasser - (2:25)',
          videoid: '7NR8_EygcoM',
          guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
          dbName: 'setup_widget_progress_scheduling',
          done: false,
          stepNum: 6
        }
      ],
      stepsEN: [
        {
          title: 'Create grades/groups - (0:52)',
          videoid: 'WdXydJxGFpI',
          guide: 'https://youtu.be/WdXydJxGFpI',
          dbName: 'setup_widget_progress_klass',
          done: false,
          stepNum: 1
        },
        {
          title: 'Create teachers - (0:43)',
          videoid: 'D83kXuPIZzE',
          guide: 'https://youtu.be/D83kXuPIZzE',
          dbName: 'setup_widget_progress_users',
          done: false,
          stepNum: 2
        },
        {
          title: 'Create classrooms / locations - (1:01)',
          videoid: 'UBI-WnWOtdQ',
          guide: 'https://youtu.be/UBI-WnWOtdQ',
          dbName: 'setup_widget_progress_rooms',
          done: false,
          stepNum: 3
        },
        {
          title: 'Choose school holidays - (0:36)',
          videoid: 'CkUvNQQgMoQ',
          guide: 'https://youtu.be/CkUvNQQgMoQ',
          dbName: 'setup_widget_progress_vacation',
          done: false,
          stepNum: 5
        },
        {
          title: 'Create shared calendar - (2:56)',
          videoid: 'aIvpXbHwYeA',
          guide: 'https://youtu.be/aIvpXbHwYeA',
          dbName: 'setup_widget_progress_merge',
          done: false,
          stepNum: 4
        },
        {
          title: 'Create subjects - (2:31)',
          videoid: 'EpEfabVl7yw',
          guide: 'https://youtu.be/EpEfabVl7yw',
          dbName: 'setup_widget_progress_subjects',
          done: false,
          stepNum: 6
        },
        {
          title: 'Schedule classes  - (3:31)',
          videoid: 'UXZpf-wAh-U',
          guide: 'https://youtu.be/UXZpf-wAh-U',
          dbName: 'setup_widget_progress_scheduling',
          done: false,
          stepNum: 7
        }
      ]
    }
  },
  methods: {
    fireWhenDataIsReady () {
      this.findNextStep()
      if (this.userSettings.setupWidgetOpen !== false) {
        eventbus.showSetupWidget = true
      }
    },
    findNextStep () {
      this.showLocalOnboardingArrow = false
      for (let i = 0; i < this.stepNumbers.length; i++) {
        if (!this.stepNumbers[i].done) {
          this.calcOnboardArrowTop(i)
          return
        }
      }
    },
    calcOnboardArrowTop (nextStepIdx) {
      if (document.querySelectorAll('.js-onboard-item-click')[nextStepIdx]) {
        const nextStepBCRTop = document.querySelectorAll('.js-onboard-item-click')[nextStepIdx].getBoundingClientRect().top
        this.onboardArrowTopPx = nextStepBCRTop - 8
        this.showLocalOnboardingArrow = true
      }
    },
    openYouTube (videoid) {
      eventbus.youTubeVideoId = videoid
      eventbus.isOpenYouTubePopup = true
    },
    checkProgress () {
      for (let i = 0; i < this.progressed.length; i++) {
        for (let j = 0; j < this.stepNumbers.length; j++) {
          if (this.stepNumbers[j].dbName === this.progressed[i]) {
            this.stepNumbers[j].done = true
          }
        }
      }
      this.fireWhenDataIsReady()
    },
    setShowModal (panel) {
      if (this.showModal) {
        this.animateSlide = true
        this.closeModal(panel)
      } else {
        this.animateSlide = true
        this.openModal(panel)
      }
    },
    openModal () {
      eventbus.showSetupWidget = true
      this.$store.dispatch('updateUserSettings', {'setupWidgetOpen': true})
      const wrapper = document.querySelector('#djs-content-container')
      if (!wrapper.classList.contains('djs_setup_widget_open')) {
        wrapper.classList.add('djs_setup_widget_open')
      }
    },
    closeModal () {
      eventbus.showSetupWidget = false
      this.$store.dispatch('updateUserSettings', {'setupWidgetOpen': false})
      document.querySelector('#djs-content-container').classList.remove('djs_setup_widget_open')
    },
    showIntercom () {
      window.Intercom('show')
    },
    /* For future steps */
    stepFnc (stepNum, title) {
      eventbus.showOnboardingArrow = true
      this.$store.commit('setOnboardingStep', stepNum)
      window.Intercom('trackEvent', 'Watched Onboarding Video: ' + title)
      if (stepNum === 5) {
        setTimeout(() => {
          const el = document.querySelector('.js-onboarding-arrow-planning .djs-header-dropdown-click')
          el.click()
        }, 500)
      }
    },
    isCalIdAKlass (calId) {
      if (this.klassCals[calId]) {
        return true
      }
    }
  },
  beforeMount () {
    // Find out if SetupWidget is open
    const settings = JSON.parse(window.USER.settings.replace(/&quot;/g, '"'))
    if (settings.setupWidgetOpen !== false) {
      eventbus.showSetupWidget = true
    }
  },
  mounted () {
    // Intercom: Tracking devise
    if (!this.$helpers.getSessionStorage('doSession')) {
      window.Intercom('trackEvent', 'Session Device ' + this.$helpers.checkUserDevice())
    }
    // Intercom: Tracking devise
    this.$helpers.setSessionStorage('doSession', true)
    // Listen for the ROR FullCalendar-event
    window.addEventListener('vue_dropped_subject', e => {
      if (window.SCHOOL.state === 'demo' && this.isCalIdAKlass(e.detail.cal_id)) {
        window.Intercom('trackEvent', 'Dropped Event In Class')
        this.$store.dispatch('updateUserSettings', {'setup_widget_progress_scheduling': true})
      }
    }, false)
    // Listen for the ROR FullCalendar-event
    window.addEventListener('vue_dropped_subject_no_teacher', e => {
      if (window.SCHOOL.state === 'demo' && this.isCalIdAKlass(e.detail.cal_id)) {
        window.Intercom('trackEvent', 'Fail No Teacher On Subject In Class')
      }
    }, false)
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.setup-widget {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9980;
  font-size: 12px !important;
  width: 320px;
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.2);
  background-color: white;
  transform: translateX(100%);
}

.setup-widget.animateSlide {
  transition: transform 0.5s;
}

.setup-widget.setupWidgetOpen {
  transform: translateX(0);
}

.setup-widget__button {
  position: absolute;
  cursor: pointer;
  top: 120px;
  left: -80px;
  color: white;
  display: flex;
  border-radius: 4px 4px 0 0;
  padding: 10px;
  font-weight: bold;
  transform: rotate(-90deg);
  background-color: var(--blue);
  box-shadow: 0px -8px 11px -4px rgba(0, 0, 0, .2);
}

@media print {
  .setup-widget__button {
    display: none;
  }
}

.setup-widget__button__close {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 2px;
}

.setup-widget__header {
  background-color: var(--blue);
  padding-top: 20px;
}

.setup-widget__header h2 {
  text-align: center;
}

.setup-widget__steps {
  padding: 0 20px 20px 20px;
}

.setup-widget__steps .setup-widget__steps__headline {
  text-transform: uppercase;
  padding: 0;
  font-weight: bold;
  border: 0 !important;
  height: auto;
}

.setup-widget__steps__step {
  border: 1px dashed white !important;
  color: white;
  background: transparent;
  display: flex;
  cursor: pointer;
  text-align: center;
  padding: 2px 10px;
  user-select: none;
  font-weight: bold;
  line-height: 22px;
  border-radius: 4px;
  height: auto;
  align-items: center;
  margin-bottom: 10px;
}

.setup-widget__steps li {
  background: transparent !important;
}

.setup-widget__steps li > .step__button__video-guide {
  display: flex;
  width: 100%;
  padding: 5px 10px;
  color: white !important;
  background: transparent !important;
}

.setup-widget__steps li > a:hover {
  background: transparent !important;
}

.setup-widget__steps li.isDone {
  border: 1px solid #cccccc !important;
}

.isDone .step-text {
  text-decoration: line-through;
}

.setup-widget__steps__step:active {
  transform: scale(0.95);
  transition: all 0.4s
}

.setup-widget__steps li .step__number {
  font-size: 12px !important;
  color: #468AD7;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  margin-right: 10px;
  border: 1px solid var(--blue);
  border-radius: 50%;
}

.setup-widget__steps li .step__number.stepNumberDone {
  background-color: var(--green);
  color: white;
}

.setup-widget__steps li span.step-text {
  font-size: 12px !important;
  text-transform: initial;
}

.step__number__play {
  padding-left: 2px;
}

.support-section {
  padding: 5px 20px;
}

.support-section__list {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

.support-section__list > a {
  color: var(--blue) !important;
  font-size: 12px;
  line-height: 24px;
  text-transform: uppercase;
  font-weight: 600;
  white-space: nowrap;
  transition: color .15s ease-out;
  border-radius: 4px;
  margin-bottom: 5px;
}

.support-section__list > a:hover {
  color: var(--dark-blue) !important;
}

</style>



// WEBPACK FOOTER //
// SetupWidget.vue?4163332c